import { render } from "./IconFile.vue?vue&type=template&id=39859de4"
import script from "./IconFile.vue?vue&type=script&lang=ts"
export * from "./IconFile.vue?vue&type=script&lang=ts"
script.render = render

export default script